/* DuduBubu Cart Upsell — XB-style cart drawer upsell with one-click Add,
 * Shopify express checkout buttons, item count + total on Checkout.
 * No external services. Works with the Dawn-family cart drawer and cart page. */
(function () {
  'use strict';
  if (window.__dbsCartUpsell) return; // section + app embed both present -> run once
  window.__dbsCartUpsell = true;

  var cfgEl = document.getElementById('dbs-cart-upsell-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.enabled && !cfg.expressButtons) return;

  var EXCLUDE = String(cfg.excludeTags || '')
    .split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
  var IS_INDIA = cfg.country === 'IN';
  var LOCALE = document.documentElement.lang || 'en';
  var CACHE_KEY = 'dbs-cu-recs-v2:' + (cfg.country || '') + ':' + (cfg.currency || '') + ':' + LOCALE;
  var CACHE_TTL = 30 * 60 * 1000;
  var SP_HANDLE = 'shipping-protection';

  var recCache = loadCache();
  var recInflight = {};
  var cartInflight = null;
  var lastKey = null;
  var lastProducts = [];
  var expressNode = null;
  var renderTimer = null;
  var cartCache = null; // last full cart we know about (from /cart.js or the theme's own cart requests)
  var cartCacheAt = 0;

  /* ---------- helpers ---------- */
  var FMT = (function (sample) {
    var m = /^(.*?)1(\D?)234(\D)56(.*)$/.exec(String(sample || '').trim());
    return m ? { pre: m[1], thou: m[2], dec: m[3], post: m[4] } : null;
  })(cfg.moneySample);

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    if (FMT) {
      var parts = amount.toFixed(2).split('.');
      return FMT.pre + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, FMT.thou) + FMT.dec + parts[1] + FMT.post;
    }
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cfg.currency || 'EUR' }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + (cfg.currency || '');
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  function xboostActive() {
    if (!cfg.hideWhenXboost) return false;
    return !!(window.XBOOST_CART || document.getElementById('xboost-upsell-slide-cart-root') ||
      document.querySelector('.xboost-cart-slide'));
  }

  function idle(fn) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 200);
  }

  /* ---------- recommendation cache (per tab session) ---------- */
  function loadCache() {
    try {
      var raw = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
      var now = Date.now(), out = {};
      Object.keys(raw).forEach(function (k) { if (raw[k] && now - raw[k].t < CACHE_TTL) out[k] = raw[k]; });
      return out;
    } catch (e) { return {}; }
  }
  function saveCache() {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(recCache)); } catch (e) {}
  }
  function slim(p) {
    return {
      id: p.id, title: p.title, handle: p.handle, url: p.url, tags: p.tags, available: p.available,
      requires_selling_plan: p.requires_selling_plan, featured_image: p.featured_image,
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price, available: v.available,
          featured_image: v.featured_image ? { src: v.featured_image.src } : null
        };
      })
    };
  }

  function fetchRecs(productId, intent) {
    var key = productId + ':' + intent;
    if (recCache[key]) return Promise.resolve(recCache[key].p);
    if (recInflight[key]) return recInflight[key];
    var url = (cfg.recommendationsUrl || '/recommendations/products') + '.json?product_id=' +
      encodeURIComponent(productId) + '&limit=10&intent=' + intent;
    recInflight[key] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var list = ((j && j.products) || []).map(slim);
        recCache[key] = { t: Date.now(), p: list };
        saveCache();
        return list;
      })
      .catch(function () { return []; })
      .then(function (list) { delete recInflight[key]; return list; });
    return recInflight[key];
  }

  function getCart() {
    if (cartInflight) return cartInflight;
    cartInflight = fetch((cfg.cartUrl || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartInflight = null; cartCache = c; cartCacheAt = Date.now(); return c; }, function (e) { cartInflight = null; throw e; });
    return cartInflight;
  }

  /* ---------- picking products ---------- */
  function eligible(p, inCart) {
    if (!p || !p.available || inCart[p.id] || p.handle === SP_HANDLE) return false;
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    for (var i = 0; i < EXCLUDE.length; i++) if (tags.indexOf(EXCLUDE[i]) > -1) return false;
    if ((tags.indexOf('india-only') > -1) !== IS_INDIA) return false; // India buyers see India products only
    if (p.requires_selling_plan) return false;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    return !!(v && Number(v.price) > 0);
  }

  function loadProducts(cart) {
    var items = (cart.items || []).filter(function (i) { return i.handle !== SP_HANDLE; })
      .sort(function (a, b) { return b.final_line_price - a.final_line_price; });
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var seeds = [];
    items.forEach(function (i) { if (seeds.indexOf(i.product_id) < 0 && seeds.length < 2) seeds.push(i.product_id); });
    if (!seeds.length) return Promise.resolve([]);
    var intents = cfg.intent === 'complementary' ? ['complementary', 'related'] : ['related'];
    var jobs = [];
    intents.forEach(function (intent) { seeds.forEach(function (s) { jobs.push(fetchRecs(s, intent)); }); });
    return Promise.all(jobs).then(function (lists) {
      var seen = {}, out = [];
      lists.forEach(function (list) {
        list.forEach(function (p) {
          if (out.length >= cfg.count || seen[p.id] || !eligible(p, inCart)) return;
          seen[p.id] = true;
          out.push(p);
        });
      });
      return out;
    });
  }

  /* ---------- markup ---------- */
  function priceHtml(price, compare) {
    var was = Math.max(Number(compare || 0), Number(price));
    return (was > Number(price) ? '<s class="dbs-cu__was">' + money(was) + '</s> ' : '') +
      '<span class="dbs-cu__now">' + money(price) + '</span>';
  }

  var CHEV_L = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function cardHtml(p, i) {
    var variants = (p.variants || []).filter(function (v) { return v.available; });
    var v = variants[0];
    var single = variants.length === 1 && /default title/i.test(v.title || '');
    var image = (v.featured_image && v.featured_image.src) || p.featured_image;
    var options = variants.map(function (x) {
      return '<option value="' + x.id + '" data-price="' + x.price + '" data-compare="' + (x.compare_at_price || '') + '"' +
        (x.featured_image && x.featured_image.src ? ' data-img="' + esc(img(x.featured_image.src, 180)) + '"' : '') + '>' +
        esc(x.title) + '</option>';
    }).join('');
    return '' +
      '<div class="dbs-cu__card" data-product-id="' + p.id + '" data-index="' + i + '">' +
        '<a class="dbs-cu__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (image ? '<img src="' + esc(img(image, 180)) + '" alt="" loading="lazy" decoding="async" width="90" height="90">' : '') +
        '</a>' +
        '<div class="dbs-cu__info">' +
          '<a class="dbs-cu__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="dbs-cu__price">' + priceHtml(v.price, v.compare_at_price) + '</div>' +
          '<div class="dbs-cu__row">' +
            (single ? '<input type="hidden" class="dbs-cu__variant" value="' + v.id + '">'
              : '<select class="dbs-cu__variant" aria-label="' + esc(p.title) + ' option">' + options + '</select>') +
            '<button type="button" class="dbs-cu__add"' +
              (cfg.accent ? ' style="background:' + esc(cfg.accent) + ';border-color:' + esc(cfg.accent) + '"' : '') + '>' +
              esc(cfg.addLabel || 'Add') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function sectionHtml(products) {
    var many = products.length > 1;
    return '' +
      '<p class="dbs-cu__heading">' + esc(cfg.heading || 'You might also like these') + '</p>' +
      '<div class="dbs-cu__viewport' + (many ? ' has-arrows' : '') + '">' +
        (many ? '<button type="button" class="dbs-cu__arrow dbs-cu__arrow--prev" data-dir="-1" aria-label="Previous">' + CHEV_L + '</button>' : '') +
        '<div class="dbs-cu__track">' + products.map(cardHtml).join('') + '</div>' +
        (many ? '<button type="button" class="dbs-cu__arrow dbs-cu__arrow--next" data-dir="1" aria-label="Next">' + CHEV_R + '</button>' : '') +
      '</div>' +
      (many ? '<div class="dbs-cu__dots">' + products.map(function (p, i) {
        return '<button type="button" class="dbs-cu__dot' + (i === 0 ? ' is-active' : '') + '" data-go="' + i + '" aria-label="' + (i + 1) + ' / ' + products.length + '"></button>';
      }).join('') + '</div>' : '');
  }

  /* ---------- where things go ---------- */
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function drawerEmpty() { var d = drawerEl(); return !d || d.classList.contains('is-empty'); }

  function placements() {
    var out = [];
    var d = drawerEl();
    var items = d && !drawerEmpty() && d.querySelector('cart-drawer-items');
    if (items) out.push({ host: items, mode: 'append', where: 'drawer' });
    if (cfg.showOnCartPage && onCartPage()) {
      var main = document.querySelector('cart-items#main-cart-items, #main-cart-items, cart-items');
      if (main && !main.closest('cart-drawer')) out.push({ host: main, mode: 'after', where: 'page' });
    }
    return out;
  }

  function mount(spot, products) {
    var scope = spot.mode === 'after' ? spot.host.parentNode : spot.host;
    var el = scope.querySelector(':scope > .dbs-cu[data-where="' + spot.where + '"]');
    if (!products.length) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'dbs-cu dbs-cu--' + spot.where + (spot.where === 'page' ? ' page-width' : '');
      el.setAttribute('data-where', spot.where);
      el.setAttribute('role', 'region');
      el.setAttribute('aria-label', cfg.heading || 'You might also like these');
      if (spot.mode === 'append') spot.host.appendChild(el);
      else spot.host.parentNode.insertBefore(el, spot.host.nextSibling);
    }
    if (el.getAttribute('data-key') !== lastKey) {
      el.innerHTML = sectionHtml(products);
      el.setAttribute('data-key', lastKey);
      bindTrack(el);
    }
  }

  /* ---------- XB-style touches on the drawer ---------- */
  var LOCK = '<svg class="dbs-lock" viewBox="0 0 20 20" aria-hidden="true"><path d="M6.5 8.5V6.5a3.5 3.5 0 1 1 7 0v2" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><rect x="4.5" y="8.5" width="11" height="8.5" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';

  function decorate(cart) {
    var d = drawerEl();
    if (!d || !cart) return;
    var count = (cart.items || []).reduce(function (n, i) { return i.handle === SP_HANDLE ? n : n + i.quantity; }, 0);
    var heading = d.querySelector('.drawer__heading');
    if (heading) {
      if (!heading.hasAttribute('data-dbs-base')) heading.setAttribute('data-dbs-base', heading.textContent.trim());
      var h = heading.getAttribute('data-dbs-base') + (count ? ' • (' + count + ')' : '');
      if (heading.textContent !== h) heading.textContent = h;
    }
    var btn = d.querySelector('#CartDrawer-Checkout');
    if (btn && count) {
      if (!btn.hasAttribute('data-dbs-base')) btn.setAttribute('data-dbs-base', btn.textContent.trim());
      var label = btn.getAttribute('data-dbs-base') + ' • ' + money(cart.total_price);
      var cur = btn.querySelector('.dbs-checkout-label');
      if (!cur || cur.textContent !== label) {
        btn.innerHTML = LOCK + '<span class="dbs-checkout-label">' + esc(label) + '</span>';
      }
    }
  }

  function ensureExpress() {
    if (!cfg.expressButtons || xboostActive() || drawerEmpty()) return;
    var src = document.getElementById('dbs-express-source');
    if (!expressNode && src) {
      expressNode = src.querySelector('.dbs-express');
      // rendered for an empty cart: Shopify then only offers some wallets (e.g. no Google Pay)
      expressStale = src.getAttribute('data-count') === '0';
    }
    if (!expressNode) return;
    var ctas = document.querySelector('cart-drawer .drawer__footer .cart__ctas');
    if (!ctas) return;
    if (!ctas.contains(expressNode)) ctas.appendChild(expressNode);
    maybeRefreshExpress();
  }

  // Express buttons rendered while the cart was empty (or didn't exist yet) don't show every
  // wallet: re-fetch them once the cart has items.
  var expressRefreshing = false, expressTries = 0, expressStale = false;
  function maybeRefreshExpress() {
    var acc = expressNode && expressNode.querySelector('shopify-accelerated-checkout-cart');
    if (!acc || expressRefreshing || expressTries >= 3) return;
    if (acc.getAttribute('cart-id') && !expressStale) return;
    expressRefreshing = true;
    expressTries++;
    var url = cfg.sectionId
      ? location.pathname + '?sections=' + encodeURIComponent(cfg.sectionId)
      : location.pathname + location.search;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return cfg.sectionId ? r.json().then(function (j) { return j[cfg.sectionId]; }) : r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var freshSrc = doc.querySelector('#dbs-express-source');
        var fresh = freshSrc && freshSrc.querySelector('.dbs-express');
        var freshAcc = fresh && fresh.querySelector('shopify-accelerated-checkout-cart');
        if (!fresh || !freshAcc || !freshAcc.getAttribute('cart-id') || freshSrc.getAttribute('data-count') === '0') return;
        var node = document.importNode(fresh, true);
        if (expressNode.parentNode) expressNode.parentNode.replaceChild(node, expressNode);
        expressNode = node;
        expressStale = false;
        ensureLocal();
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { expressRefreshing = false; }, 5000); });
  }

  /* ---------- local pay buttons for the visitor's country ---------- */
  // Klarna in Europe, Bancontact in Belgium, Satispay in Italy, MB WAY in Portugal, Alipay for
  // Chinese-language browsers... Only methods that are switched on in Shopify Payments are used
  // (icons come from shop.enabled_payment_types). Tapping one opens checkout, where it's offered.
  var METHOD_NAMES = {
    klarna: 'Klarna', bancontact: 'Bancontact', satispay: 'Satispay', mbway: 'MB WAY', bizum: 'Bizum',
    alipay: 'Alipay', wechatpay: 'WeChat Pay', ideal: 'iDEAL', twint: 'TWINT', blik: 'BLIK',
    mobilepay: 'MobilePay', swish: 'Swish', eps: 'EPS', przelewy24: 'Przelewy24', paypal: 'PayPal'
  };
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function codes(s) { return String(s || '').toUpperCase().split(/[^A-Z]+/).filter(Boolean); }

  var localMethodsCache = null;
  function localMethods() {
    if (localMethodsCache) return localMethodsCache;
    localMethodsCache = [];
    var src = document.getElementById('dbs-pay-icons');
    if (!cfg.localButtons || !src) return localMethodsCache;
    var icons = {};
    Array.prototype.forEach.call(src.querySelectorAll('[data-type]'), function (el) {
      icons[norm(el.getAttribute('data-type'))] = el;
    });
    var country = String(cfg.country || '').toUpperCase();
    var want = [];
    String(cfg.localRules || '').split(',').forEach(function (rule) {
      var parts = rule.split(':');
      if (parts.length === 2 && parts[0].trim().toUpperCase() === country) want.push(norm(parts[1]));
    });
    if (codes(cfg.klarnaCountries).indexOf(country) > -1) want.push('klarna');
    if (cfg.alipayChinese) {
      var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
      if (langs.some(function (l) { return /^zh/i.test(l || ''); })) want.push('alipay');
    }
    want.forEach(function (k) {
      if (icons[k] && localMethodsCache.length < 2 && !localMethodsCache.some(function (m) { return m.key === k; })) {
        localMethodsCache.push({ key: k, icon: icons[k] });
      }
    });
    return localMethodsCache;
  }

  // The icon copies keep their gradients/masks working on their own (unique ids per copy).
  var idSeq = 0;
  function uniquifyIds(svg) {
    var map = {}, any = false;
    Array.prototype.forEach.call(svg.querySelectorAll('[id]'), function (el) {
      var fresh = el.id + '-dbs' + (++idSeq);
      map[el.id] = fresh;
      el.id = fresh;
      any = true;
    });
    if (!any) return;
    Array.prototype.forEach.call(svg.querySelectorAll('*'), function (el) {
      ['fill', 'stroke', 'mask', 'clip-path', 'filter', 'style'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v || v.indexOf('#') < 0) return;
        var nv = v.replace(/url\(\s*["']?#([^"')\s]+)["']?\s*\)/g, function (all, id) {
          return map[id] ? 'url(#' + map[id] + ')' : all;
        });
        if (nv !== v) el.setAttribute(a, nv);
      });
    });
  }

  function buildLocal(where, n) {
    var list = localMethods().slice(0, n);
    if (!list.length) return null;
    var wrap = document.createElement('div');
    wrap.className = 'dbs-local dbs-local--' + where + (list.length > 1 ? ' dbs-local--two' : '');
    list.forEach(function (m) {
      var name = METHOD_NAMES[m.key] || m.key;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dbs-local__btn';
      b.setAttribute('data-method', m.key);
      b.setAttribute('aria-label', 'Pay with ' + name);
      var svg = m.icon.querySelector('svg');
      if (svg) {
        svg = svg.cloneNode(true);
        svg.setAttribute('class', 'dbs-local__icon');
        svg.setAttribute('aria-hidden', 'true');
        svg.removeAttribute('aria-labelledby');
        var title = svg.querySelector('title');
        if (title) title.parentNode.removeChild(title);
        uniquifyIds(svg);
        b.appendChild(svg);
      } else {
        b.insertAdjacentHTML('beforeend', '<span class="dbs-local__name" aria-hidden="true">' + esc(name) + '</span>');
      }
      wrap.appendChild(b);
    });
    return wrap;
  }

  // Turn Shopify's small payment icon into a full brand button: the icon's card background becomes
  // the button colour (Klarna pink, Satispay red, white for Bancontact / MB WAY / Alipay) and the
  // logo is cropped so it fills the button. The logo artwork itself is Shopify's official icon.
  function parseRgb(c) {
    var m = /rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/.exec(c || '');
    return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
  }
  function brandify(btn) {
    if (btn.__dbsBranded) return true;
    var svg = btn.querySelector('svg');
    if (!svg) return false;
    var vb = String(svg.getAttribute('viewBox') || '0 0 38 24').split(/[\s,]+/).map(Number);
    var W = vb[2] || 38, H = vb[3] || 24, bg = null;
    var kids = Array.prototype.slice.call(svg.children);
    try {
      if (!svg.getBBox().width) return false; // not laid out yet, try again later
      kids.forEach(function (k) {
        if (!/^(path|rect)$/i.test(k.tagName) || k.hasAttribute('transform')) return;
        var bb = k.getBBox();
        var isFrame = bb.x <= 1.5 && bb.y <= 1.5 && bb.width >= W - 3 && bb.height >= H - 3 &&
          bb.width <= W + 0.5 && bb.height <= H + 0.5;
        if (!isFrame) return;
        var cs = getComputedStyle(k);
        var op = (parseFloat(cs.opacity) || 0) * (cs.fillOpacity === '' ? 1 : parseFloat(cs.fillOpacity));
        if (!bg && op > 0.5 && parseRgb(cs.fill)) bg = cs.fill;
        k.parentNode.removeChild(k);
      });
      if (bg) { // big shapes in the button colour are just background too (e.g. Bancontact's inner card)
        Array.prototype.slice.call(svg.children).forEach(function (k) {
          if (!/^(path|rect)$/i.test(k.tagName) || k.hasAttribute('transform')) return;
          var bb = k.getBBox();
          if (getComputedStyle(k).fill === bg && bb.width * bb.height >= 0.3 * W * H) k.parentNode.removeChild(k);
        });
      }
      var box = svg.getBBox();
      if (box.width && box.height) {
        var pad = Math.max(box.width, box.height) * 0.03;
        svg.setAttribute('viewBox', [box.x - pad, box.y - pad, box.width + 2 * pad, box.height + 2 * pad].join(' '));
      }
    } catch (e) { return false; }
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    var rgb = parseRgb(bg) || [255, 255, 255];
    var light = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255 > 0.8;
    btn.style.backgroundColor = 'rgb(' + rgb.join(',') + ')';
    btn.style.borderColor = light ? 'rgba(0,0,0,.14)' : 'rgb(' + rgb.join(',') + ')';
    btn.classList.add('is-branded');
    btn.__dbsBranded = true;
    return true;
  }
  function brandifyAll(node) {
    if (!node) return;
    Array.prototype.forEach.call(node.querySelectorAll('.dbs-local__btn'), brandify);
  }

  // Never more than 2 pay buttons, always side by side: a local method only takes a free spot next
  // to Shopify's wallets (e.g. when only Shop Pay shows). With 2 wallets there's no extra button at all.
  var MAX_PAY_BUTTONS = 2;
  function walletCount(acc) {
    var n = 0, els = acc.getElementsByTagName('*');
    for (var i = 0; i < els.length; i++) if (/-BUTTON$/.test(els[i].tagName) && els[i].offsetWidth > 0) n++;
    return n;
  }

  function firstWallet(acc) {
    var els = acc.getElementsByTagName('*');
    for (var i = 0; i < els.length; i++) if (/-BUTTON$/.test(els[i].tagName) && els[i].offsetHeight > 0) return els[i];
    return null;
  }
  function syncHeight(s) { // same height and same line as the wallet button next to it
    if (!s.node) return;
    if (s.node.parentNode) brandifyAll(s.node);
    var wb = s.acc && s.lastW > 0 ? firstWallet(s.acc) : null;
    if (!wb || !s.node.parentNode) {
      s.node.style.removeProperty('--dbs-pay-h');
      s.node.style.marginTop = '';
      return;
    }
    s.node.style.setProperty('--dbs-pay-h', wb.offsetHeight + 'px');
    var cur = parseFloat(s.node.style.marginTop) || 0;
    var off = Math.round(wb.getBoundingClientRect().top - (s.node.getBoundingClientRect().top - cur));
    var mt = off > 0 && off < 40 ? off + 'px' : '';
    if (s.node.style.marginTop !== mt) s.node.style.marginTop = mt;
  }

  var localSlots = {};
  function placeLocal(where, row, acc) {
    var s = localSlots[where] || (localSlots[where] = { where: where, shown: 0, lastW: -1 });
    if (s.row !== row || s.acc !== acc) {
      if (s.mo) s.mo.disconnect();
      if (s.ro) s.ro.disconnect();
      if (s.row && s.row !== row) s.row.classList.remove('dbs-row--local');
      s.row = row;
      s.acc = acc;
      s.mo = s.ro = null;
      if (acc) {
        var kick = function () { decideLocal(s); };
        s.mo = new MutationObserver(kick);
        s.mo.observe(acc, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        if (window.ResizeObserver) { s.ro = new ResizeObserver(kick); s.ro.observe(acc); }
      }
    }
    decideLocal(s);
  }

  function decideLocal(s) {
    var w = s.acc ? walletCount(s.acc) : 0;
    var want = Math.min(Math.max(0, MAX_PAY_BUTTONS - w), localMethods().length);
    clearTimeout(s.timer);
    if (!want) { s.lastW = w; hideLocal(s); return; } // no room next to the wallets: don't add it
    if (s.shown === want && s.node && s.node.parentNode === s.row) { s.lastW = w; syncHeight(s); return; }
    // Wallets render a moment after the cart (Apple/Google Pay can join later), so only add the
    // button once they've settled; re-attach at once if nothing changed (theme re-rendered the cart).
    var delay = !s.acc || (s.shown && w === s.lastW) ? 0 : (w === 0 ? 4000 : 1200);
    s.timer = setTimeout(function () {
      var w2 = s.acc ? walletCount(s.acc) : 0;
      if (w2 !== w) { decideLocal(s); return; }
      s.lastW = w2;
      showLocal(s, want);
    }, delay);
  }

  function showLocal(s, n) {
    if (s.node && s.shown !== n) {
      if (s.node.parentNode) s.node.parentNode.removeChild(s.node);
      s.node = null;
    }
    if (!s.node) s.node = buildLocal(s.where, n);
    if (!s.node || !s.row || !s.row.isConnected) return;
    s.shown = n;
    if (s.row.lastElementChild !== s.node) s.row.appendChild(s.node);
    s.row.classList.toggle('dbs-row--local', !!s.acc && s.lastW > 0); // same row as the wallet
    syncHeight(s);
  }

  function hideLocal(s) {
    if (s.node && s.node.parentNode) s.node.parentNode.removeChild(s.node);
    if (s.row) s.row.classList.remove('dbs-row--local');
    s.shown = 0;
  }

  function ensureLocal() {
    if (!cfg.localButtons || xboostActive() || !localMethods().length) return;
    if (!drawerEmpty()) {
      var ctas = document.querySelector('cart-drawer .drawer__footer .cart__ctas');
      if (ctas) {
        var inRow = expressNode && ctas.contains(expressNode);
        placeLocal('drawer', inRow ? expressNode : ctas,
          inRow ? expressNode.querySelector('shopify-accelerated-checkout-cart') : null);
      }
    }
    if (onCartPage()) {
      var dyn = document.querySelector('.cart__dynamic-checkout-buttons');
      if (dyn && !dyn.closest('cart-drawer')) {
        placeLocal('page', dyn, dyn.querySelector('shopify-accelerated-checkout-cart'));
      } else {
        var pageBtn = document.getElementById('checkout');
        var pageCtas = pageBtn && pageBtn.closest('.cart__ctas');
        if (pageCtas) placeLocal('page', pageCtas, null);
      }
    }
  }

  function rootPath() { return (cfg.rootUrl || '/').replace(/\/?$/, '/'); }

  // Orders remember which cart button was used (hidden cart attributes, visible on the order in admin).
  function tagCart(method) {
    var attrs = { _dbs_pay_button: method };
    if (cfg.country) attrs._dbs_country = cfg.country;
    var save = fetch((cfg.cartUrl || '/cart') + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
    return Promise.race([save, new Promise(function (r) { setTimeout(r, 1500); })]);
  }

  function track(method) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('dbs_cart_local_pay_click', { method: method, country: cfg.country });
      }
    } catch (e) {}
  }

  function payLocal(btn) {
    var method = btn.getAttribute('data-method');
    track(method);
    btn.classList.add('is-loading');
    var inDrawer = !!btn.closest('cart-drawer');
    tagCart(method).then(function () {
      var checkout = inDrawer ? document.getElementById('CartDrawer-Checkout') : document.getElementById('checkout');
      if (checkout && !checkout.disabled) checkout.click();
      else location.href = rootPath() + 'checkout';
    });
    setTimeout(function () { btn.classList.remove('is-loading'); }, 4000);
  }

  /* ---------- render ---------- */
  function render() {
    if (xboostActive()) return;
    ensureExpress();
    ensureLocal();
    var spots = cfg.enabled ? placements() : [];
    if (!drawerEl() && !spots.length) return;
    var fresh = cartCache && Date.now() - cartCacheAt < 2000;
    (fresh ? Promise.resolve(cartCache) : getCart()).then(function (cart) {
      decorate(cart);
      if (!cfg.enabled) return;
      var items = (cart.items || []).filter(function (i) { return i.handle !== SP_HANDLE; });
      if (!items.length) {
        document.querySelectorAll('.dbs-cu').forEach(function (el) { el.remove(); });
        return;
      }
      var key = items.map(function (i) { return i.product_id + 'x' + i.quantity; }).join(',');
      var p = key === lastKey ? Promise.resolve(lastProducts) : loadProducts(cart);
      return p.then(function (products) {
        lastKey = key;
        lastProducts = products;
        placements().forEach(function (s) { mount(s, products); });
      });
    }).catch(function (e) { if (window.console) console.warn('[dbs-cart-upsell]', e); });
  }

  function schedule(delay) {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, delay == null ? 120 : delay);
  }

  // Runs right after the theme swaps the cart markup (same frame), so the count, total,
  // express buttons and upsell don't flicker away while the fresh cart loads.
  function quickPaint() {
    if (xboostActive()) return;
    ensureExpress();
    ensureLocal();
    if (cartCache) decorate(cartCache);
    if (cfg.enabled && lastProducts.length && lastKey) placements().forEach(function (s) { mount(s, lastProducts); });
  }

  // Learn the new cart from the theme's own cart requests (no extra request needed).
  (function watchCartRequests() {
    if (!window.fetch) return;
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var m = CART_RE.exec(url);
        if (m) {
          p.then(function (r) {
            if (!r || !r.ok) return;
            if (m[1] === 'add') { cartCache = null; getCart().catch(function () {}); return; } // add only returns the new line
            r.clone().json().then(function (j) {
              if (j && typeof j.item_count === 'number' && j.items) { cartCache = j; cartCacheAt = Date.now(); }
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  })();

  /* ---------- slider: dots, arrows, variant images ---------- */
  // One shared ResizeObserver for all sliders (drawer opening, rotation, window resize).
  var tracks = [];
  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) { var f = entries[i].target.__dbsSync; if (f) f(); }
  }) : null;
  if (!ro) window.addEventListener('resize', function () {
    for (var i = 0; i < tracks.length; i++) if (tracks[i].__dbsSync) tracks[i].__dbsSync();
  });

  function bindTrack(el) {
    var track = el.querySelector('.dbs-cu__track');
    if (!track) return;
    var dots = el.querySelectorAll('.dbs-cu__dot');
    var prev = el.querySelector('.dbs-cu__arrow--prev');
    var next = el.querySelector('.dbs-cu__arrow--next');
    var ticking = false;
    function sync() {
      ticking = false;
      var first = track.children[0];
      if (!first) return;
      var step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      if (!step || !track.clientWidth) return; // not visible yet (drawer closed)
      var maxScroll = track.scrollWidth - track.clientWidth;
      // with 2-3 cards per view (cart page) there are fewer scroll positions than cards
      var last = Math.max(0, Math.round(maxScroll / step));
      var i = Math.min(last, Math.round(track.scrollLeft / step));
      if (track.scrollLeft >= maxScroll - 2) i = last;
      el.classList.toggle('is-static', maxScroll < 2);
      for (var k = 0; k < dots.length; k++) {
        dots[k].hidden = k > last;
        dots[k].classList.toggle('is-active', k === i);
      }
      if (prev) prev.disabled = track.scrollLeft < 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
    }
    function queue() { if (ticking) return; ticking = true; requestAnimationFrame(sync); }
    track.__dbsSync = queue;
    track.addEventListener('scroll', queue, { passive: true });
    tracks = tracks.filter(function (t) {
      if (t.isConnected) return true;
      if (ro) ro.unobserve(t);
      t.__dbsSync = null;
      return false;
    });
    tracks.push(track);
    if (ro) ro.observe(track);
    queue();
  }

  function goTo(el, i) {
    var track = el.querySelector('.dbs-cu__track');
    var card = track && track.children[i];
    if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function updateCard(card) {
    var sel = card.querySelector('select.dbs-cu__variant');
    if (!sel) return;
    var o = sel.options[sel.selectedIndex];
    card.querySelector('.dbs-cu__price').innerHTML = priceHtml(o.getAttribute('data-price'), o.getAttribute('data-compare'));
    var src = o.getAttribute('data-img');
    var im = card.querySelector('.dbs-cu__media img');
    if (src && im && im.getAttribute('src') !== src) im.setAttribute('src', src);
  }

  /* ---------- add to cart ---------- */
  function add(card, btn) {
    if (btn.disabled) return;
    var input = card.querySelector('.dbs-cu__variant');
    var id = Number(input && input.value);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var page = onCartPage();
    var drawer = drawerEl();
    var useDrawer = !page && drawer && typeof drawer.renderContents === 'function';
    var body = {
      items: [{ id: id, quantity: 1, properties: { _dbs_upsell: 'cart' } }],
      sections: useDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble',
      sections_url: location.pathname
    };
    fetch((cfg.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error((res.j && (res.j.description || res.j.message)) || 'Could not add');
          err.status = res.status;
          throw err;
        }
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('dbs_cart_upsell_added', { variantId: id, productId: card.getAttribute('data-product-id') });
          }
        } catch (e) {}
        lastKey = null;
        var sections = res.j.sections || {};
        if (useDrawer && sections['cart-drawer']) {
          var state = res.j.items && res.j.items[0] ? Object.assign({}, res.j.items[0], { sections: sections }) : res.j;
          drawer.renderContents(state);
        } else if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var inner = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && inner) bubble.innerHTML = inner.innerHTML;
        }
        if (page) {
          var ci = document.querySelector('cart-items');
          if (ci && typeof ci.onCartUpdate === 'function') ci.onCartUpdate();
          else { location.reload(); return; }
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dbs-cart-upsell', productVariantId: id }); } catch (e) {}
        }
        schedule(150);
      })
      .catch(function (e) {
        if (window.console) console.warn('[dbs-cart-upsell] add failed', e);
        btn.textContent = e && e.status === 422 ? 'Sold out' : 'Try again';
        setTimeout(function () { btn.textContent = label; }, 1800);
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var addBtn = t.closest('.dbs-cu__add');
    if (addBtn) { e.preventDefault(); add(addBtn.closest('.dbs-cu__card'), addBtn); return; }
    var localBtn = t.closest('.dbs-local__btn');
    if (localBtn) { e.preventDefault(); payLocal(localBtn); return; }
    var arrow = t.closest('.dbs-cu__arrow');
    if (arrow) {
      e.preventDefault();
      var track = arrow.closest('.dbs-cu').querySelector('.dbs-cu__track');
      track.scrollBy({ left: Number(arrow.getAttribute('data-dir')) * track.clientWidth, behavior: 'smooth' });
      return;
    }
    var dot = t.closest('.dbs-cu__dot');
    if (dot) { e.preventDefault(); goTo(dot.closest('.dbs-cu'), Number(dot.getAttribute('data-go'))); }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('dbs-cu__variant')) updateCard(e.target.closest('.dbs-cu__card'));
  });

  // Re-render only when the theme replaces cart markup. Our own changes and the
  // shipping-protection widget are ignored, so there are no render loops.
  var OWN = '.dbs-cu, .dbs-express, .dbs-local, .drawer__heading, #CartDrawer-Checkout, [data-dbs-sp]';
  function ownNode(n) {
    if (!n) return true;
    if (n.nodeType !== 1) return true; // text / comment nodes
    return n.matches(OWN) || !!n.closest(OWN);
  }
  function relevant(muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes') {
        if (m.target.classList && m.target.classList.contains('active')) return true; // drawer opened
        continue;
      }
      if (m.target.closest && m.target.closest(OWN)) continue;
      var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
      for (var k = 0; k < nodes.length; k++) if (!ownNode(nodes[k])) return true;
    }
    return false;
  }

  function observe() {
    var d = drawerEl();
    if (d) {
      new MutationObserver(function (muts) { if (relevant(muts)) { quickPaint(); schedule(60); } }).observe(d, { childList: true, subtree: true });
      new MutationObserver(function (muts) { if (relevant(muts)) schedule(0); }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
    var ci = document.querySelector('cart-items');
    if (ci && !ci.closest('cart-drawer')) {
      new MutationObserver(function (muts) { if (relevant(muts)) { quickPaint(); schedule(60); } }).observe(ci, { childList: true, subtree: true });
    }
  }

  function init() {
    observe();
    document.addEventListener('cart:updated', function () { schedule(); });
    document.addEventListener('cart:refresh', function () { schedule(); });
    if (onCartPage()) render();
    else idle(render); // prepare the drawer quietly so it's instant when opened
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
